<pr-page-splash>
  <pr-account-actions />
</pr-page-splash>
